import { StyledSkeleton } from './style';

export const Loader = ({ loading, rows = 3, children }) => (
  <StyledSkeleton paragraph={{ rows }} active loading={loading}>
    {children}
  </StyledSkeleton>
);
